import { BaseResponse } from './base-response'

// eslint-disable-next-line no-shadow
export enum AbsenceLedgerMode {
  Simulation = 'simulation',
  Historical = 'historical',
}

export interface LedgerOverviewRow {
  id: string
  absencePeriod: string
  hours: number
  hundredPercentUsed: number
  fiftyPercentUsed: number
  discretionaryPay: string
  unpaid: number
}

export interface LedgerBreakdownRow {
  id: string
  date: string
  usedHours: number
  hundredPercentUsed: number
  fiftyPercentUsed: number
  balance100: number
  balance50: number
  discretionaryPay: string
  unpaid: number
  isNonWorkingDay: boolean
  isAdjustmentRow: boolean
}

export interface GetEmployeeAbsenceTransactionsOSPLedgerBalanceResponse extends BaseResponse {
  overviewRows: LedgerOverviewRow[]
  breakdownRows: LedgerBreakdownRow[]
}
